import { useAsync } from 'react-use';

import { addressToLatLong } from '../utils/addressToLatLong';

export const useAddressToLatLong = (address: string) =>
  useAsync(async () => await addressToLatLong(address), [address]);
